import React, { useState } from 'react';
import ButtonPolicy from "src/components/Permission/ButtonPolicy";
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import './contract.css';
import OperatorForm from './operatorForm';
import Item from 'src/components/ItemMonitoring/ItemForm';
import { getAllContracts,getAllCompanies , deleteMntOperator} from 'src/apis/contract';
import { getAllOperators } from 'src/apis/tickets';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import {
  useNavigate,
  useRouteLoaderData,
  defer,
  Await,
} from "react-router-dom";
import { useEffect } from 'react';
const MntOperator = () => {
const contractsAndCompanies = useRouteLoaderData("operator");
console.log(contractsAndCompanies);
  const [notebook, setNotebook] = useState([]);
 const  [companies,setCompanies]=useState([]); 
  const [showAddNewNote, setShowAddNewNote] = useState(false);
  const [newNoteTitle, setNewNoteTitle] = useState('');
  const [newNoteDescription, setNewNoteDescription] = useState('');
  const [date, setDate] = useState(new Date());
  const [openNotebook, setOpenNotebook] = useState(false);
  const [selectedNotebook, setSelectedNotebook] = useState(null);

  const [modal, setModal] = useState({ open: false, formElement: null });
  const [externalSubmit, setExternalSubmit] = useState(false);

  const navigate = useNavigate();
  const handleExternalSubmit = (submitting, closeModal = false) => {
    if (submitting) {
      setExternalSubmit(true);
    } else {
      if (closeModal) {
        handleClose();
        navigate();
      }
      setExternalSubmit(false);
    }
  };


  const handleOpenAddNewNote = () => {
    setShowAddNewNote(true);
  };

  const handleClose = () => {
    setShowAddNewNote(false);
  };
  useEffect(() => {
    console.log("in useEfect")
    if (contractsAndCompanies ) {
     setNotebook(contractsAndCompanies.info[0]);
     setCompanies(contractsAndCompanies.info[1]);
    }
  }, [contractsAndCompanies]);
  
  const handleAddNewNote = (event) => {
    event.preventDefault();
    const NoteLength = notebook.length + 1;
    const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const newNote = {
      id: NoteLength,
      date: date.toISOString().substring(0, 10),
      time: currentTime,
      Title: newNoteTitle,
      Description: newNoteDescription
    };
    setNotebook([...notebook, newNote]);
    setNewNoteTitle('');
    setNewNoteDescription('');
    setShowAddNewNote(true);
  };

  const handleNewNoteDescriptionChange = (event) => {
    setNewNoteDescription(event.target.value);
  };

  const handleNewNoteTitleChange = (event) => {
    setNewNoteTitle(event.target.value);
  };

  const handleOpenNotebook = (note_) => {
    setSelectedNotebook(note_);
    setOpenNotebook(true);
  };

  const handleClosed = () => {
    setOpenNotebook(false);
  };

  const handleDeleteNotebook = () => {
    const confirmDelete = window.confirm('Are you sure you want to delete this Company?');
    if (confirmDelete) {
      deleteMntOperator(selectedNotebook.id)
        .then((response) => {
          if (response.success) {
            // Successfully deleted the company, now remove it from your state
            const updatedCompanies = notebook.filter(company => company.id !== selectedNotebook.id);
            setNotebook(updatedCompanies);
          } else {
            // Handle error if the deletion was not successful
            console.error(response.errors);
          }
          setOpenNotebook(false); // Close the dialog
        })
        .catch((error) => {
          // Handle API error here
          console.error(error);
          setOpenNotebook(false); // Close the dialog
        });
    }
    
  };

  return (
    <div className='companiesContainer'>
      <h1>Maintenance Operators</h1>
      <Grid container>
        <Grid md={3} lg={3} sm={6} xs={12}>
          <div className='cardHolder'>
            <div className='addNewNote'>
              <ButtonPolicy onClick={handleOpenAddNewNote}>+</ButtonPolicy>
            </div>
          </div>
        </Grid>

 {/* //Dialog to aad a new Notebook// */}
 <Dialog open={showAddNewNote} onClose={() => setShowAddNewNote(false)}>
                <div className='cover'>
                  <DialogContent>
                    <OperatorForm
                      props={{
                        custom: true,
                        onSubmit: handleExternalSubmit,
                        externalSubmit: externalSubmit,
                        
                        ticketData: null
                      }} />
                  </DialogContent>
                  <DialogActions>
                    <ButtonPolicy className='closeAddNoteButton' onClick={handleClose}>Close</ButtonPolicy>
                    <ButtonPolicy className='addNoteBookButton' onClick={() => handleExternalSubmit(true)}>Add</ButtonPolicy>
                  </DialogActions>
                </div>
              </Dialog>


        {notebook && notebook.length > 0 ? (
          notebook.map(note => (
            <>
              <Grid md={3} lg={3} sm={6} xs={12}>
                <div className='cardHolder'>
            
                  <div className='companyCard' key={note.id} onClick={() => handleOpenNotebook(note)} >
                  <div className='companyName'>{note.name} {note.surname}</div>
                  <div className='companyDetails'> 
      
                    <div><AttachEmailIcon/>  email : {note.email} </div>
                    </div>
                  </div>
                </div>
              </Grid>
              {/* //Dialog to show each note book details// */}
              <Dialog open={openNotebook} onClose={handleClosed}>
                {selectedNotebook && (
                  <>
                    <DialogTitle><div className='NoteTitle'>  {selectedNotebook.name} - {selectedNotebook.surname}</div></DialogTitle>
                    <DialogContent>
                   
                      <h4> Working Under: </h4>
                      <div className='NoteDescription'> {selectedNotebook.maintenanceCompany.name}  </div>
                      <div className='NoteDescription'>  {selectedNotebook.maintenanceCompany.taxNumber}</div>
                    
                    </DialogContent>
                    <DialogActions>
                      <ButtonPolicy className='closeAddNoteButton' onClick={handleClosed}>Close</ButtonPolicy>
                      <ButtonPolicy className='addNoteBookButton' onClick={() => handleDeleteNotebook(note)} >Delete</ButtonPolicy>
                    
                    </DialogActions>
                  </>
                )}
              </Dialog>

             
            </>
          ))
        ) : (
          <p>Click the add button to add a new Operator.</p>
        )}

      </Grid>
    </div>
  );
};

export default MntOperator;
async function loadOperators() {

  const response = await getAllOperators();
  const response1 = await getAllCompanies();

  return [response,response1];
}

export async function loader() {
 
  return defer({
    info: await loadOperators(),
  });
}